import { createAsyncThunk } from "@reduxjs/toolkit";
import { getContractNoteSingle } from "../../../helpers/fakebackend_helper";



export const contractNote_singleThunk = createAsyncThunk("contractNote_singleThunk", async ({ params, token }, { rejectWithValue } ) => {
  try {
    const response = await getContractNoteSingle( params, token);
    return response;
  } catch (error) {
    // Properly pass the error structure to the reducer
    return rejectWithValue({
      code: error.data?.code || error.code,
      message: error.message,
      data: error.data
    });
  }
});










